import script from "./ScrollPane.vue?vue&type=script&setup=true&lang=js"
export * from "./ScrollPane.vue?vue&type=script&setup=true&lang=js"

import "./ScrollPane.vue?vue&type=style&index=0&id=082b57ec&lang=scss&scoped=true"

import exportComponent from "H:\\project\\tako\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-082b57ec"]])

export default __exports__